"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withHandlePost = void 0;
const withHandlePost = async (requestAsPromise, options = {}) => requestAsPromise.then(data => data.status >= 200 && data.status < 300).catch(error => {
  options.onError?.(error);
  return false;
});
exports.withHandlePost = withHandlePost;